<script lang="ts">
  import { toastStore } from '$lib/toast/toast.svelte';
  import ToastList from './toastList.svelte';
  import TaskList from './taskList.svelte';
</script>

<!-- Default toast host: a fixed container in the top-right, just under the main
     header. When a page mounts its own <ToastOutlet />, that outlet takes over
     and the toasts here stand down (see toastStore.activeOutlet). The
     background tasks always float here, with the toasts below them. -->
<div class="toastAnchor">
  <TaskList />
  {#if toastStore.activeOutlet === null}
    <ToastList />
  {/if}
</div>

<style lang="scss">
  .toastAnchor {
    position: fixed;
    z-index: var(--z-index-toast);
    right: 20px;
    // Sit just under the main layout header (56px tall; see (admin)/Header.svelte),
    // keeping the same 20px gap used on the right.
    top: calc(56px + 20px);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }
</style>
